import {
  MapPinIcon,
  PhoneIcon,
  ArrowTopRightOnSquareIcon,
  EnvelopeIcon,
  ClockIcon,
} from "@heroicons/react/24/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { faPlane } from "@fortawesome/free-solid-svg-icons";
import Copyright from "./Copyright";

export default function Contact() {
  return (
    <div className="relative bottom-0 right-0 bg-cyan-600 px-8 py-16 pb-8 z-10">
      <h2 className="text-4xl font-bold text-center text-white mb-8">
        Onde nos pode encontrar?
      </h2>

      {/* Social Media Links with Hover Animation */}
      <div className="flex justify-center mt-8 space-x-6 mb-6">
        <a
          href="https://www.linkedin.com/company/belle-epoque-viagens-e-turismo/about/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-gray-200 transition duration-300 transform hover:scale-125 hover:rotate-6"
        >
          <FontAwesomeIcon icon={faLinkedin} size="2x" />
        </a>
        <a
          href="https://www.facebook.com/belleepoque2017"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-gray-200 transition duration-300 transform hover:scale-125 hover:rotate-6"
        >
          <FontAwesomeIcon icon={faFacebook} size="2x" />
        </a>
        <a
          href="https://www.instagram.com/belleepoqueviagens/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-gray-200 transition duration-300 transform hover:scale-125 hover:rotate-6"
        >
          <FontAwesomeIcon icon={faInstagram} size="2x" />
        </a>
      </div>

      <div className="max-w-5xl mx-auto bg-white shadow-md rounded-lg p-8 flex flex-col md:flex-row items-start space-y-6 md:space-y-0 md:space-x-8">
        {/* Left: Location Details */}
        <div className="flex-1">
          <div className="flex items-center mb-2">
            <PhoneIcon className="h-6 w-6 text-cyan-600 mr-4" />
            <a href="tel:+351233094915" className="text-cyan-600 text-lg">
              +351 935 945 664
            </a>
          </div>
          <div className="flex items-center mb-2">
            <EnvelopeIcon className="h-6 w-6 text-cyan-600 mr-4" />
            <a
              href="mailto:geral@belle-epoque.pt"
              className="text-cyan-600 text-lg"
            >
              geral@belle-epoque.pt
            </a>
          </div>
          <div className="flex items-start mb-2">
            <MapPinIcon className="h-10 w-10 text-cyan-600 mr-4" />
            <p className="text-cyan-600 text-lg mb-0">
              Centro Comercial Figueira Shopping FozCenter Loja 12/13, 3080-036
              Figueira da Foz
            </p>
          </div>
          <div className="flex items-center mb-2">
            <ClockIcon className="h-6 w-6 text-cyan-600 mr-4" />
            <p className="text-cyan-600 text-lg mb-0">
              09h30-13h00 / 14h30-19h30
            </p>
          </div>
          <div className="flex items-center mb-2">
            <FontAwesomeIcon
              icon={faPlane}
              className="h-6 w-6 text-cyan-600 mr-4"
            />
            <p className="text-cyan-600 text-lg mb-0">RNAVT: 6712</p>
          </div>

          <a
            href="https://maps.app.goo.gl/QxFz71Z1WTqA3RvU8"
            target="_blank"
            rel="noopener noreferrer"
            className="text-flamingo text-cyan-600 font-semibold hover:underline flex items-center"
          >
            Ver no Google Maps{" "}
            <ArrowTopRightOnSquareIcon className="ml-2 h-5 w-5" />
          </a>
        </div>

        {/* Right: Google Map Embed */}
        <div className="flex-1 w-full h-72 md:h-full">
          <iframe
            title="Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1662.858110172349!2d-8.855223262951478!3d40.14907365336425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2237e932f026dd%3A0x56beeb86c0fae3db!2sAg%C3%AAncia%20de%20Viagens%20Belle%20Epoque%20RNAVT%206712!5e0!3m2!1spt-PT!2spt!4v1728463863131!5m2!1spt-PT!2spt"
            width="100%"
            height="225px"
            style={{ border: 0 }}
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          />
        </div>
      </div>

      {/* Add Copyright component below */}
      <Copyright />
    </div>
  );
}
